import { BaseModel } from "model/BaseModel";
import Pessoa from "model/administracao/cadastro/Pessoa";
import Usuario from "model/administracao/cadastro/Usuario";
import Arquivo from "model/arquivo/Arquivo";
import Atividade from "./Atividade";

export default class AtividadeApontamento implements BaseModel {

    id: number;
    codigo: string | null;
    descricao: string;
    usuario: Usuario | null;
    atividade: Atividade | null;
    pessoa: Pessoa | null;
    dataInicio: Date | null;
    dataFim: Date | null;
    faturado: boolean;
    arquivos: Arquivo[];

    constructor(
        id = 0,
        codigo = null,
        descricao = '',
        usuario: Usuario|null = null,
        atividade = null,
        pessoa = null,
        dataInicio = null,
        dataFim = null,
        faturado = false,
        arquivos = []
    ) {
        this.id = id;
        this.codigo = codigo;
        this.descricao = descricao;
        this.usuario = usuario;
        this.atividade = atividade;
        this.pessoa = pessoa;
        this.dataInicio = dataInicio;
        this.dataFim = dataFim;
        this.faturado = faturado;
        this.arquivos = arquivos;
    }

}
